export default {
  title: {
    welcome: 'Welcome Bonus Image',
    app_signup: 'Mobile App Sign-Up Bonus Image',
  },
  select: {
    generate_title: 'Generate an image with AI',
    generate_subtitle: "We'll create one based on your cashback program.",
    generate_cta: 'Generate',
    upload_link: 'or upload from your device',
    rate_limit_company: {
      title: 'We need a moment to catch up',
      description: 'Your restaurant has generated a lot of images this hour. Try again in {{time}}.',
    },
    rate_limit_cashback_bonus: {
      title: 'Taking a quick breather',
      description: "Looks like you've tried this bonus a few times in a row. We'll be ready again in {{time}}.",
    },
  },
  generating: {
    title: 'Generating your image…',
    progress: {
      cooking: 'Cooking up something tasty…',
      plating: 'Plating…',
      finishing: 'Adding the finishing touches…',
    },
  },
  preview: {
    alt: 'Generated bonus image',
    hint: 'Not quite right? Regenerate, or continue to crop the image.',
    click_to_expand: 'Click to expand',
    regenerate: 'Regenerate',
    continue: 'Continue to edit',
  },
  toasts: {
    upload_success: 'Image uploaded successfully.',
    upload_failed: 'Failed to upload image.',
    delete_success: 'Image deleted successfully.',
    delete_failed: 'Failed to delete image.',
    generate_success: 'Image generated successfully.',
    generate_failed: 'Failed to start image generation.',
    generate_timeout: 'Image is still being generated. It will appear here when ready.',
    rate_limit_company: 'Hourly image limit reached for this restaurant. Try again in {{time}}.',
    rate_limit_cashback_bonus: 'A few too many tries for this bonus just now — try again in {{time}}.',
  },
  time: {
    seconds_one: '1 second',
    seconds_other: '{{count}} seconds',
    minutes_one: '1 minute',
    minutes_other: '{{count}} minutes',
    hours_one: '1 hour',
    hours_other: '{{count}} hours',
  },
};
